import React, { useState, useRef, useEffect } from "react";
import styles from "./CustomSortDropdown.module.scss";

const CustomSortDropdown = ({
  isMobileView = false,
  options = [],
  defaultValue = "",
  // type = "APPLICATION",
  value,
  setValue,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setValue(option);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.dropdownWrapper} ref={dropdownRef}>
      <div className={styles.dropdownToggle} onClick={() => setOpen(!open)}>
        {/* <p>
          Sort by : {!isMobileView && <span>{value}</span>}
        </p>
        {isMobileView &&
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9998 10.667L11.3332 13.3337L8.6665 10.667" stroke="#7E7E7E" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.3335 13.3337V2.66699" stroke="#7E7E7E" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 5.33366L4.66667 2.66699L7.33333 5.33366" stroke="#7E7E7E" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.6665 2.66699V13.3337" stroke="#7E7E7E" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        } */}
        <p>
          <span className={styles.SortByText}>Sort by : </span>
          <span>{value}</span>
          <svg
            width="13"
            height="13"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.9998 10.667L11.3332 13.3337L8.6665 10.667"
              stroke="#7E7E7E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.3335 13.3337V2.66699"
              stroke="#7E7E7E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 5.33366L4.66667 2.66699L7.33333 5.33366"
              stroke="#7E7E7E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.6665 2.66699V13.3337"
              stroke="#7E7E7E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </p>
        {!isMobileView && (
          <svg
            className={styles.icon}
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L5 5L9 1" stroke="#9a9a9a" strokeWidth="1.5" />
          </svg>
        )}
      </div>
      {open && (
        <ul className={styles.dropdownList}>
          {options.map((opt) => (
            <li
              key={opt}
              className={`${styles.dropdownItem} ${
                value === opt ? styles.active : ""
              }`}
              onClick={() => handleSelect(opt)}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSortDropdown;
